import { VirtualTableHeadCell } from '../../virtualized-table/types';

export const headCells: VirtualTableHeadCell[] = [
  {
    Header: 'Report Date',
    accessor: 'reportDate',
  },
  {
    Header: 'Queued',
    accessor: 'queued',
  },
  {
    Header: 'Downloaded Successfully',
    accessor: 'downloadedSuccessfully',
  },
  {
    Header: 'Flashed Successfully',
    accessor: 'flashedSuccessfully',
  },
  {
    Header: 'Flash Failed',
    accessor: 'flashFailed',
  },
  {
    Header: 'Initial Download Failed',
    accessor: 'initialDownloadFailed',
  },
  {
    Header: 'Retry 1 Failed',
    accessor: 'autoRetry1Failed',
  },
  {
    Header: 'Retry 2 Failed',
    accessor: 'autoRetry2Failed',
  },
  {
    Header: 'Stale Files Removed',
    accessor: 'staleFilesRemoved',
  },
  {
    Header: 'Downloaded No Response',
    accessor: 'downloadedNoResponse',
  },
];

export const sortableAccessors = {
  reportDate: true,
  queued: true,
  downloadedSuccessfully: true,
  flashedSuccessfully: true,
  flashFailed: true,
  initialDownloadFailed: true,
  autoRetry1Failed: true,
  autoRetry2Failed: true,
  staleFilesRemoved: true,
  downloadedNoResponse: true,
};
